import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import Content from '../../../../components/Editor/Page/Content';

interface ContentOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: ContentOwnProps) => {
	const {
		editor: { pages },
	} = state;

	return {
		html: pages[page] ? pages[page].html : '',
	};
};

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Page/Content/index.tsx